<section class="flex flex-col gap-4">
  <div class="flex flex-col gap-2">
    <pr-deposit-section-heading
      anchor="treatment-configurations"
      heading="Treatment Configurations"
    />
    <p class="!mb-0 text-sm text-slate-600">
      Require a deposit for an individual treatment. These are the treatments a
      booking is made of, and what a practitioner adds to a treatment plan.
    </p>
    <pr-information-box>
      When a treatment here has a deposit, that amount replaces the Treatment
      Template amount for the booking. This includes bookings made online, which
      use the treatment behind the chosen template.
    </pr-information-box>
  </div>

  <mat-form-field class="w-full" subscriptSizing="dynamic">
    <mat-label>Treatment Configurations requiring a deposit</mat-label>
    <mat-select
      multiple
      aria-label="Treatment Configurations requiring a deposit"
      [formControl]="selectedConfigurationIds"
    >
      <mat-option>
        <ngx-mat-select-search
          noEntriesFoundLabel="No Treatment Configurations found"
          placeholderLabel="Search Treatment Configurations..."
          [formControl]="searchControl"
        />
      </mat-option>
      @for (
        configuration of filteredConfigurations();
        track configuration.ref.path
      ) {
        <mat-option [value]="configuration.ref.id">
          {{ configuration.name }}
        </mat-option>
      }
    </mat-select>
    <mat-hint>
      Search and select from all configured treatments. Only selected treatments
      require a deposit. Deposits for Treatments are captured when booking the
      appointment.
    </mat-hint>
  </mat-form-field>

  <div class="flex flex-col divide-y divide-slate-200">
    @for (row of rows(); track row.configuration.ref.path) {
      <div class="flex flex-col gap-2 py-2 sm:flex-row sm:gap-4">
        <div class="min-w-0 flex-1 py-3 font-medium">
          {{ row.configuration.name }}
        </div>
        <mat-form-field class="w-full sm:w-40" subscriptSizing="dynamic">
          <mat-label>Deposit</mat-label>
          <span matTextPrefix>$&nbsp;</span>
          <input
            matInput
            type="number"
            min="0.01"
            [formControl]="row.amountDollars"
            [matTooltip]="row.configuration.name + ' deposit amount'"
          />
          @if (row.amountDollars.hasError('required')) {
            <mat-error>Deposit amount is required</mat-error>
          }
          @if (row.amountDollars.hasError('min')) {
            <mat-error>Deposit amount must be greater than 0</mat-error>
          }
        </mat-form-field>
        <button
          mat-icon-button
          type="button"
          color="warn"
          class="shrink-0"
          [matTooltip]="
            'Remove ' + row.configuration.name + ' deposit requirement'
          "
          [attr.aria-label]="
            'Remove ' + row.configuration.name + ' deposit requirement'
          "
          (click)="removeConfiguration(row.configuration.ref.id)"
        >
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    }
  </div>
</section>
